import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import {
  HeaderContext,
  injectFlexRenderContext
} from '@tanstack/angular-table';

@Component({
  selector: 'datatable-sortable-column-header',
  template: `
    <button
      type="button"
      (click)="toggleSort()"
      class="capitalize hover:bg-accent hover:text-accent-foreground inline-flex items-center justify-center outline-none px-3 rounded-md shrink-0 text-sm transition-all whitespace-nowrap font-medium gap-1.5 h-8"
      [class.bg-accent]="isSorted()"
    >
      <span>{{ columnLabel() }}</span>
      @if (sortDirection(); as direction) {
        @if (direction === 'asc') {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="size-4"
          >
            <path d="m21 16-4 4-4-4"></path>
            <path d="M17 20V4"></path>
          </svg>
        } @else if (direction === 'desc') {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="size-4"
          >
            <path d="m3 8 4-4 4 4"></path>
            <path d="M7 4v16"></path>
          </svg>
        } @else {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="size-4"
          >
            <path d="m21 16-4 4-4-4"></path>
            <path d="M17 20V4"></path>
            <path d="m3 8 4-4 4 4"></path>
            <path d="M7 4v16"></path>
          </svg>
        }
      }
    </button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatatableSortableColumnHeaderComponent<T> {
  context = injectFlexRenderContext<HeaderContext<T, unknown>>();

  readonly columnLabel = computed(() => {
    const column = this.context.column;
    const columnDef = column.columnDef;
    if (typeof columnDef.header === 'string') {
      return columnDef.header;
    }
    const id = column.id;
    return id.charAt(0).toUpperCase() + id.slice(1);
  });

  readonly isSorted = computed(() => {
    return this.context.column.getIsSorted() !== false;
  });

  readonly sortDirection = computed((): 'asc' | 'desc' | null => {
    const sortState = this.context.column.getIsSorted();
    if (sortState === 'asc') return 'asc';
    if (sortState === 'desc') return 'desc';
    return null;
  });

  protected toggleSort(): void {
    const column = this.context.column;
    if (column.getCanSort()) {
      column.toggleSorting(undefined, true);
    }
  }
}
